import { Box, Grid, Typography, withStyles } from "@mui/material";
import React from "react";
// @ts-ignore
import ReCAPTCHA from "react-google-recaptcha";
import { connect } from "react-redux";
import Bouton from "../../../../../components/Button/Bouton";
import InputField from "../../../../../components/input/InputField";
import { isEmail } from "../../../../../helpers/validators";
import ErreursConstante from "../../../../../_constantes/erreursConstantes.json";
import styles from "../styles";
import { Field, Form } from "react-final-form";

export interface ContactFormData {
  nom: string;
  prenom: string;
  email: string;
  societe: string;
  telephone?: string;
  message: string;
  response: string;
}

interface ContactFormError {
  nom?: string;
  prenom?: string;
  email?: string;
  societe?: string;
  telephone?: string;
  message?: string;
}
interface Props {
  fetching?: boolean;
  errorCaptcha?: string;
  onCaptchaValue(value?: any): void;
  withoutMessage?: boolean;
  onSubmit(params: ContactFormData): void;
}
function ContactForm({
  onCaptchaValue,
  fetching,
  errorCaptcha,
  onSubmit,
  withoutMessage,
}: Props) {
  const onChange = (value: any) => {
    onCaptchaValue(value);
  };

  return (
    <Box className={"container"} sx={styles}>
      <h2>Vous souhaitez être contacté ?</h2>
      <div>
        <Form validate={validateForm} name="contactForm" onSubmit={onSubmit}>
          {({ handleSubmit, pristine, submitting, form, values }) => (
            <form
              onSubmit={handleSubmit}
              noValidate
              className={"formContainer"}
            >
              <div className={"formContact"}>
                <Grid container wrap="nowrap" className={"inputFormName"}>
                  <Field
                    component={InputField}
                    name="nom"
                    required
                    label="Nom"
                    maxLength={50}
                  />{" "}
                  <Field
                    component={InputField}
                    name="prenom"
                    required
                    label="Prénom"
                    maxLength={50}
                  />
                </Grid>
                <Field
                  component={InputField}
                  name="societe"
                  required
                  label="Société"
                  maxLength={80}
                />
                <Field
                  component={InputField}
                  name="telephone"
                  label="Téléphone"
                  maxLength={20}
                />
                <Field
                  component={InputField}
                  name="email"
                  required
                  label="E-mail"
                  maxLength={65}
                />
                {!withoutMessage && (
                  <Field
                    component={InputField}
                    name="message"
                    multiline
                    required
                    rows={3}
                    label="Message"
                    placeholder="Ajouter un message"
                    maxLength={500}
                    note=" Si vous souhaitez une offre personnalisée ou essayer vertuloo gratuitement n'hésitez pas à nous indiquer le nombre de lots gérés, assurés, non assurés."
                  />
                )}
                <Grid container direction="column">
                  <ReCAPTCHA
                    sitekey="6LchDdsUAAAAAD1UiVPur8IYgfIhZAVsxjlCKRq2"
                    onChange={onChange}
                  />
                  {errorCaptcha && (
                    <Typography variant="body2" color="error">
                      {errorCaptcha}
                    </Typography>
                  )}
                </Grid>
                <Grid container justifyContent="flex-end">
                  <Bouton
                    label="Envoyer"
                    type="submit"
                    variant="contained"
                    color="primary"
                    fetching={fetching}
                  />
                </Grid>
              </div>
            </form>
          )}
        </Form>
      </div>
    </Box>
  );
}

const validateForm = (values: ContactFormData): ContactFormError => {
  const errors: ContactFormError = {} as ContactFormError;

  if (!values.nom) {
    errors.nom = ErreursConstante.formulaire.generale.champObligatoire;
  }

  if (!values.prenom) {
    errors.prenom = ErreursConstante.formulaire.generale.champObligatoire;
  }

  if (!values.email) {
    errors.email = ErreursConstante.formulaire.generale.champObligatoire;
  } else if (values.email && !isEmail(values.email)) {
    errors.email = ErreursConstante.formulaire.generale.emailIncorrect;
  }
  if (!values.societe) {
    errors.societe = ErreursConstante.formulaire.generale.champObligatoire;
  }

  if (!values.message) {
    errors.message = ErreursConstante.formulaire.generale.champObligatoire;
  }

  return errors;
};

export default ContactForm;
